import type { User } from '../../types';

export const ADMIN_PERMISSIONS = [
  {
    id: 'curriculum.manage',
    label: 'Curriculum',
    description: 'Create and edit curricula, classes, activities, notes, slides, and class resources.',
  },
  {
    id: 'certifications.manage',
    label: 'Certifications',
    description: 'Manage the learning library, modules, certifications, and completion approvals.',
  },
] as const;

export type AdminPermission = typeof ADMIN_PERMISSIONS[number]['id'];

export function normalizeAdminPermissions(value: unknown): AdminPermission[] {
  if (!Array.isArray(value)) return [];
  const supported = new Set<string>(ADMIN_PERMISSIONS.map(permission => permission.id));
  return Array.from(new Set(value.filter((permission): permission is AdminPermission => typeof permission === 'string' && supported.has(permission))));
}

export function hasAdminPermission(user: User | null | undefined, permission: AdminPermission): boolean {
  return user?.isAdmin === true || normalizeAdminPermissions(user?.adminPermissions).includes(permission);
}

export function hasAnyAdminPermission(user: User | null | undefined): boolean {
  return user?.isAdmin === true || normalizeAdminPermissions(user?.adminPermissions).length > 0;
}

export function firstAdminTab(user: User | null | undefined): 'calendar' | 'learning' | 'curriculum' {
  if (user?.isAdmin === true) return 'calendar';
  if (hasAdminPermission(user, 'certifications.manage')) return 'learning';
  return 'curriculum';
}
